import React, { useCallback, useEffect, useReducer, useState } from 'react'
import { actionTypes, initialState, reducer } from './reducer'
import { Main, MainTop, MainTopTitle, MainTopLeft, MainBody, WhiteBox } from '@/components/Layout'
import { FileAttachments } from '@/components/fileAttachments'
import { Input, Label } from 'reactstrap'
import context from '@/context'
import { DropDownList } from '@/components/dropDownList'
import { InfoRow } from '@/components/InfoRow'
import { Button } from '@/components/button'
import { DatePicker } from '@/components/DatePicker'
import { ConfirmFooter } from '@/dialogs/common/confirmFooter'
import { CheckBox } from '@/components/inputs'

function InputReportsGenerator (props) {
  const [state, dispatch] = useReducer(reducer, initialState)
  const [reportingGroups, setReportingGroups] = useState([])
  let [enforceApproved, setEnforceApproved] = useState(false)

  const { files, institution, version, defaultGroup, defaultDueDate } = state
  const institutionId = institution ? institution.id : null

  const onAttachmentsChange = useCallback(event => dispatch({ type: event.operation, data: event.file }), [])
  const onInstitutionChange = useCallback(({ item }) => dispatch({ type: actionTypes.setInstitution, data: item }), [])
  const onVersionChange = useCallback((e) => dispatch({ type: actionTypes.setVersion, data: e.target.value }), [])
  const onDefaultGroupChange = useCallback(e => dispatch({ type: actionTypes.changeDefaultGroup, data: e.item }), [])
  const onDefaultDueDateChange = useCallback(dueDate => dispatch({ type: actionTypes.changeDefaultDueDate, data: dueDate }), [])
  const onGroupChange = (id, groupId) => dispatch({ type: actionTypes.changeGroup, data: { id, groupId } })
  const onDueDateChange = (id, dueDate) => dispatch({ type: actionTypes.changeDueDate, data: { id, dueDate } })
  const onRemove = (id) => dispatch({ type: actionTypes.remove, data: id })
  const onNameChange = (id, newName) => dispatch({ type: actionTypes.rename, data: { id, newName } })

  useEffect(() => {
    context.api.reportGroupsService.getReportGroups({
      pageSize: 10000,
      page: 1
    }).then(response => setReportingGroups(response.data))
      .catch()
  }, [])

  const onReset = useCallback(() => dispatch({ type: actionTypes.resetState }), [])

  const onSave = useCallback(() => {
    const imports = files.map(x => {
      return {
        fileId: x.id,
        name: x.name,
        groupId: x.groupId.id,
        dueDate: x.dueDate
      }
    })

    context.api.reportSubmissionGroupService.inputReportBulkUpload({
      institutionId: institutionId,
      version: version,
      inputReportImports: imports,
      enforceApprovedState: enforceApproved
    }).then(onReset).catch()
  }, [files, institutionId, version, enforceApproved, onReset])

  return <Main>
    <MainTop>
      <MainTopTitle>Report bulk upload</MainTopTitle>
      <MainTopLeft />
    </MainTop>
    <MainBody>
      <React.Fragment>
        <WhiteBox>
          <Label>Select institution</Label>
          <DropDownList
            dataSource={context.api.institutionService.getLookup}
            onChange={onInstitutionChange}
            value={state.institution}
          />
          <Label>Specify version (optional)</Label>
          <Input onChange={onVersionChange} type='number' />
          <CheckBox checked={enforceApproved} onChange={value => setEnforceApproved(value)} label='Enforce accepted status' />
        </WhiteBox>
        <WhiteBox>
          <Label>Editor</Label>
          {state.files.map(item =>
            <InfoRow key={item.id}>
              <Input value={item.name} onChange={(e) => onNameChange(item.id, e.target.value)} />
              <DropDownList
                clientSide
                dataSource={reportingGroups}
                value={item.groupId}
                onChange={(e) => onGroupChange(item.id, e.item)}
              />
              <DatePicker value={item.dueDate} onChange={(dueDate) => onDueDateChange(item.id, dueDate)} />
              <Button icon={'trash'} onClick={() => onRemove(item.id)} />
            </InfoRow>)}
          <hr />
          <Label>Defaults</Label>
          <InfoRow>
            <DropDownList
              clientSide
              dataSource={reportingGroups}
              value={defaultGroup}
              onChange={onDefaultGroupChange}
            />
            <DatePicker value={defaultDueDate} onChange={onDefaultDueDateChange} />
          </InfoRow>
          <ConfirmFooter
            primaryButtonText='Common.Save'
            icon='save'
            disabled={!state.institution || !state.isValid}
            onAction={onSave}
            closeDialog={onReset} />
        </WhiteBox>
        <WhiteBox>
          <Label>File attachments:</Label>
          <FileAttachments
            attachments={state.files}
            onChange={onAttachmentsChange}
            isRemoveEnabled={false}
            accept='.xlsx'
          />
        </WhiteBox>
      </React.Fragment>
    </MainBody>
  </Main>
}

export { InputReportsGenerator }



// WEBPACK FOOTER //
// ./src/internal-app/pages/inputReportsGenerator/inputReportsGenerator.js